export default class AgentModel {
  constructor (data = {}) {
    this.id = data.id || null
    this.name = data.name || ''
    this.description = data.description || ''
    this.llmProvider = data.llmProvider || ''
    const incomingConfig = data.configuration || {}
    // UX defaults for non-technical users (only applied when missing)
    this.configuration = {
      model: incomingConfig.model || '',
      temperature: (incomingConfig.temperature !== undefined && incomingConfig.temperature !== null)
        ? incomingConfig.temperature
        : 0.6,
      maxTokens: (incomingConfig.maxTokens !== undefined && incomingConfig.maxTokens !== null)
        ? incomingConfig.maxTokens
        : 2000,
      topP: (incomingConfig.topP !== undefined && incomingConfig.topP !== null)
        ? incomingConfig.topP
        : 0.75,
      systemPrompt: incomingConfig.systemPrompt || '',
      greetingText: incomingConfig.greetingText || 'Hello! How can I help you today?',
      primaryColor: incomingConfig.primaryColor || '#4F46E5',
      avatarUrl: incomingConfig.avatarUrl || '',
      maxAnonymousMessagesPerSession: (incomingConfig.maxAnonymousMessagesPerSession !== undefined && incomingConfig.maxAnonymousMessagesPerSession !== null)
        ? Number(incomingConfig.maxAnonymousMessagesPerSession)
        : 0,
      maxAuthenticatedMessagesPerSession: (incomingConfig.maxAuthenticatedMessagesPerSession !== undefined && incomingConfig.maxAuthenticatedMessagesPerSession !== null)
        ? Number(incomingConfig.maxAuthenticatedMessagesPerSession)
        : 0,
      maxAnonymousMessagesPerHour: (incomingConfig.maxAnonymousMessagesPerHour !== undefined && incomingConfig.maxAnonymousMessagesPerHour !== null)
        ? Number(incomingConfig.maxAnonymousMessagesPerHour)
        : 0,
      maxAuthenticatedMessagesPerHour: (incomingConfig.maxAuthenticatedMessagesPerHour !== undefined && incomingConfig.maxAuthenticatedMessagesPerHour !== null)
        ? Number(incomingConfig.maxAuthenticatedMessagesPerHour)
        : 0,
      maxAnonymousSessionsPerDay: (incomingConfig.maxAnonymousSessionsPerDay !== undefined && incomingConfig.maxAnonymousSessionsPerDay !== null)
        ? Number(incomingConfig.maxAnonymousSessionsPerDay)
        : 0,
      maxAuthenticatedSessionsPerDay: (incomingConfig.maxAuthenticatedSessionsPerDay !== undefined && incomingConfig.maxAuthenticatedSessionsPerDay !== null)
        ? Number(incomingConfig.maxAuthenticatedSessionsPerDay)
        : 0,
      anonymousSessionRetentionCount: (incomingConfig.anonymousSessionRetentionCount !== undefined && incomingConfig.anonymousSessionRetentionCount !== null)
        ? Number(incomingConfig.anonymousSessionRetentionCount)
        : 0,
      anonymousSessionRetentionDays: (incomingConfig.anonymousSessionRetentionDays !== undefined && incomingConfig.anonymousSessionRetentionDays !== null)
        ? Number(incomingConfig.anonymousSessionRetentionDays)
        : 0,
      authenticatedSessionRetentionCount: (incomingConfig.authenticatedSessionRetentionCount !== undefined && incomingConfig.authenticatedSessionRetentionCount !== null)
        ? Number(incomingConfig.authenticatedSessionRetentionCount)
        : 0,
      authenticatedSessionRetentionDays: (incomingConfig.authenticatedSessionRetentionDays !== undefined && incomingConfig.authenticatedSessionRetentionDays !== null)
        ? Number(incomingConfig.authenticatedSessionRetentionDays)
        : 0,
      conversationWindowSize: (incomingConfig.conversationWindowSize !== undefined && incomingConfig.conversationWindowSize !== null)
        ? Number(incomingConfig.conversationWindowSize)
        : 20,
      maxContextTokens: (incomingConfig.maxContextTokens !== undefined && incomingConfig.maxContextTokens !== null)
        ? Number(incomingConfig.maxContextTokens)
        : 8000
    }
    this.visibility = data.visibility || 'private'
    this.isActive = data.isActive !== undefined ? data.isActive : true
    this.allowHandoff = data.allowHandoff !== undefined ? data.allowHandoff : true
    this.apiKeyId = data.apiKeyId || null
    this.hasKnowledgeBase = data.hasKnowledgeBase || false
    this.knowledgeBaseEnabled = data.knowledgeBaseEnabled || false
    this.sessionCount = data.sessionCount || 0
    this.projectCount = data.projectCount || 0
    this.knowledgeBaseCount = data.knowledgeBaseCount || 0
    this.lastUsedAt = data.lastUsedAt || null
    this.createdAt = data.createdAt || null
    this.updatedAt = data.updatedAt || null
  }

  loadModel (agentData) {
    this.id = agentData.id
    this.name = agentData.name
    this.description = agentData.description
    this.llmProvider = agentData.llmProvider
    const incomingConfig = agentData.configuration || {}
    this.configuration = {
      model: incomingConfig.model || '',
      temperature: (incomingConfig.temperature !== undefined && incomingConfig.temperature !== null)
        ? incomingConfig.temperature
        : 0.6,
      maxTokens: (incomingConfig.maxTokens !== undefined && incomingConfig.maxTokens !== null)
        ? incomingConfig.maxTokens
        : 2000,
      topP: (incomingConfig.topP !== undefined && incomingConfig.topP !== null)
        ? incomingConfig.topP
        : 0.75,
      systemPrompt: incomingConfig.systemPrompt || '',
      greetingText: incomingConfig.greetingText || 'Hello! How can I help you today?',
      primaryColor: incomingConfig.primaryColor || '#4F46E5',
      avatarUrl: incomingConfig.avatarUrl || '',
      maxAnonymousMessagesPerSession: (incomingConfig.maxAnonymousMessagesPerSession !== undefined && incomingConfig.maxAnonymousMessagesPerSession !== null)
        ? Number(incomingConfig.maxAnonymousMessagesPerSession)
        : 0,
      maxAuthenticatedMessagesPerSession: (incomingConfig.maxAuthenticatedMessagesPerSession !== undefined && incomingConfig.maxAuthenticatedMessagesPerSession !== null)
        ? Number(incomingConfig.maxAuthenticatedMessagesPerSession)
        : 0,
      maxAnonymousMessagesPerHour: (incomingConfig.maxAnonymousMessagesPerHour !== undefined && incomingConfig.maxAnonymousMessagesPerHour !== null)
        ? Number(incomingConfig.maxAnonymousMessagesPerHour)
        : 0,
      maxAuthenticatedMessagesPerHour: (incomingConfig.maxAuthenticatedMessagesPerHour !== undefined && incomingConfig.maxAuthenticatedMessagesPerHour !== null)
        ? Number(incomingConfig.maxAuthenticatedMessagesPerHour)
        : 0,
      maxAnonymousSessionsPerDay: (incomingConfig.maxAnonymousSessionsPerDay !== undefined && incomingConfig.maxAnonymousSessionsPerDay !== null)
        ? Number(incomingConfig.maxAnonymousSessionsPerDay)
        : 0,
      maxAuthenticatedSessionsPerDay: (incomingConfig.maxAuthenticatedSessionsPerDay !== undefined && incomingConfig.maxAuthenticatedSessionsPerDay !== null)
        ? Number(incomingConfig.maxAuthenticatedSessionsPerDay)
        : 0,
      anonymousSessionRetentionCount: (incomingConfig.anonymousSessionRetentionCount !== undefined && incomingConfig.anonymousSessionRetentionCount !== null)
        ? Number(incomingConfig.anonymousSessionRetentionCount)
        : 0,
      anonymousSessionRetentionDays: (incomingConfig.anonymousSessionRetentionDays !== undefined && incomingConfig.anonymousSessionRetentionDays !== null)
        ? Number(incomingConfig.anonymousSessionRetentionDays)
        : 0,
      authenticatedSessionRetentionCount: (incomingConfig.authenticatedSessionRetentionCount !== undefined && incomingConfig.authenticatedSessionRetentionCount !== null)
        ? Number(incomingConfig.authenticatedSessionRetentionCount)
        : 0,
      authenticatedSessionRetentionDays: (incomingConfig.authenticatedSessionRetentionDays !== undefined && incomingConfig.authenticatedSessionRetentionDays !== null)
        ? Number(incomingConfig.authenticatedSessionRetentionDays)
        : 0,
      conversationWindowSize: (incomingConfig.conversationWindowSize !== undefined && incomingConfig.conversationWindowSize !== null)
        ? Number(incomingConfig.conversationWindowSize)
        : 20,
      maxContextTokens: (incomingConfig.maxContextTokens !== undefined && incomingConfig.maxContextTokens !== null)
        ? Number(incomingConfig.maxContextTokens)
        : 8000
    }
    this.visibility = agentData.visibility || 'private'
    this.isActive = agentData.isActive
    this.allowHandoff = agentData.allowHandoff !== undefined ? agentData.allowHandoff : true
    this.sessionCount = agentData.sessionCount || 0
    this.projectCount = agentData.projectCount || 0
    this.knowledgeBaseCount = agentData.knowledgeBaseCount || 0
    this.lastUsedAt = agentData.lastUsedAt
    this.createdAt = agentData.createdAt
    this.updatedAt = agentData.updatedAt
  }

  toCreateDto () {
    return {
      name: this.name,
      description: this.description,
      llmProvider: this.llmProvider,
      configuration: this.configuration,
      visibility: this.visibility,
      isActive: this.isActive,
      allowHandoff: this.allowHandoff
    }
  }

  getProviderIcon () {
    const icons = {
      OpenAI: 'fas fa-brain',
      Claude: 'fas fa-cloud',
      Gemini: 'fas fa-star',
      Grok: 'fas fa-bolt'
    }
    return icons[this.llmProvider] || 'fas fa-robot'
  }

  getStatusBadgeClass () {
    return this.isActive ? 'badge-success' : 'badge-secondary'
  }

  getStatusText () {
    return this.isActive ? 'Active' : 'Inactive'
  }
}
